import WavesIcon from '@material-ui/icons/Waves';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import ConceptLink from '../core/ConceptLink';

class FloatingRelationshipLink extends React.Component {

    render() {

        const { id, defaultLang, isReadOnly, link, onLink, source, graph, target, property, updateEvent, propertyGraph, viewLang } = this.props;

        return (
            <ConceptLink
                propertyGraph={propertyGraph}
                source={source}
                target={target}
                avatar={<WavesIcon data-test="floating" fontSize="small" />}
                id={id}
                graph={graph}
                otherScheme={true}
                viewLang={viewLang}
                link={link}
                onLink={onLink}
                property={property}
                isReadOnly={isReadOnly}
                loadOptions={{
                    language: viewLang && viewLang !== defaultLang ? [defaultLang, viewLang] : defaultLang
                }}
                defaultLang={defaultLang}
                updateEvent={updateEvent} />
        );
    }
}

FloatingRelationshipLink.propTypes = {
    link: PropTypes.string.isRequired,
    onLink: PropTypes.func,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    source: PropTypes.string,
    target: PropTypes.string,
    isReadOnly: PropTypes.bool,
    propertyGraph: PropTypes.string,
    property: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    updateEvent: PropTypes.func
};

export default withRouter(FloatingRelationshipLink);